import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardImpostazioniService from "./dashboardImpostazioneSaznioneService";
import { Form, InputGroup } from "react-bootstrap";
import { BsFillCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
  validNumbersInput,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import ingiunzioniList from "../../../common/mookup/MookUpIngunzioni";
import { Modal, Button, Row } from "react-bootstrap";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
toast.configure();

class Linee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      erroreGiorni:false,
      impostazioniSaznione: [
        {
          key: "giorni_notifica",
          value: "0",
        },
        {
          key: "giorni_sollecito",
          value: "0",
        },
        {
          key: "giorni_ingiunzione",
          value: "0",
        },
        {
          key: "giorni_recupero_credito",
          value: "0",
        },
        {
          key: "giorni_cancellazioni_dati",
          value: "0",
        },
        {
          key: "giorni_cancellazioni_dati_posizione",
          value: "0",
        },
        // {
        //   key:"TA1",
        //   value: "0",
        // },
        // {
        //   key:"TA2",
        //   value: "0",
        // },
        // {
        //   key:"TA3",
        //   value: "0",
        // },
        // {
        //   key:"TA4",
        //   value: "0",
        // },
        // {
        //   key:"TA5",
        //   value: "0",
        // },
        // {
        //   key:"TA6",
        //   value: "0",
        // },
        {
          key:"SZING",
          value:"0"
        },
        {
          key:"SZMC_INT",
          value:"0"
        },
        {
          key:"SZMC_RID",
          value:"0"
        },
        {
          key: "doc_status",
          value: false,
        }
      ],
      impostazioniSaznioneFissa: [
        {
          key: "giorni_notifica",
          value: "0",
        },
        {
          key: "giorni_sollecito",
          value: "0",
        },
        {
          key: "giorni_ingiunzione",
          value: "0",
        },
        {
          key: "giorni_recupero_credito",
          value: "0",
        },
        {
          key: "giorni_cancellazioni_dati",
          value: "0",
        },
        {
          key: "giorni_cancellazioni_dati_posizione",
          value: "0",
        },
        // {
        //   key:"TA1",
        //   value: "0",
        // },
        // {
        //   key:"TA2",
        //   value: "0",
        // },
        // {
        //   key:"TA3",
        //   value: "0",
        // },
        // {
        //   key:"TA4",
        //   value: "0",
        // },
        // {
        //   key:"TA5",
        //   value: "0",
        // },
        // {
        //   key:"TA6",
        //   value: "0",
        // },
        // {
        //   key:"TA7",
        //   value: "0",
        // },
        {
          key:"SZING",
          value:"0"
        },
        {
          key:"SZMC_INT",
          value:"0"
        },
        {
          key:"SZMC_RID",
          value:"0"
        },
        {
          key: "doc_status",
          value: false,
        }
      ],
      abilitazioneDiModificaSuUnLinea: [], //è un array di chiavi per abilitare e disabilitare un bottone di un area
      loading: true,
      abilitaModificaLinea: [],
      eliminaModal: false,
      idDaEliminare: 0,
      AggiungiUnaLinea: false,
      nomeArea: "",
      loadingButton:false,
      isSwaggerValueChanged: false,
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    // this.onRowClick = this.onRowClick.bind(this);
  }

  componentDidMount() {
    this.dashboardImpostazioniService = new DashboardImpostazioniService();
    // console.log(this.state.impostazioniSaznione)

    this.getSettings();
  }

  // onChangeNomelineea(event) {
  //   const idInput = event.target.id;
  //   this.state.impostazioniSaznione[idInput].nomeArea = event.target.value;
  //   this.setState({ impostazioniSaznione: this.state.impostazioniSaznione });
  // }

  // annullaElimina() {
  //   this.setState({ eliminaModal: false });
  // }

  // confremaElimna() {
  //   this.dashboardImpostazioniService.deleteLinea(
  //     this.state.idDaEliminare,
  //     (result) => {
  //       if (result.status === 200) {
  //         toast.success("Eliminato con successo");
  //       } else {
  //         toast.error("Qualcosa è andato storto");
  //       }
  //       this.dashboardImpostazioniService.getDataTableLenee((Linee) => {
  //         Linee.data.map((impostazioniSaznione) => {
  //           impostazioniSaznione.statobottne = true;
  //           impostazioniSaznione.bottoniEditi = true;
  //         });
  //         this.setState({ impostazioniSaznione: Linee.data, eliminaModal: false });
  //       });
  //     }
  //   );
  // }

  // eliminaModal() {
  //   return (
  //     <>
  //       <Modal size="sm" show={this.state.eliminaModal}>
  //         <Modal.Header>
  //           <Modal.Title>Elimina Area</Modal.Title>
  //         </Modal.Header>
  //         <Modal.Body>Sei sicuro di eliminare la Area?</Modal.Body>
  //         <Modal.Footer>
  //           <Button
  //             variant="secondary"
  //             onClick={this.annullaElimina.bind(this)}
  //           >
  //             Annulla
  //           </Button>
  //           <Button variant="danger" onClick={this.confremaElimna.bind(this)}>
  //             Elimina Area
  //           </Button>
  //         </Modal.Footer>
  //       </Modal>
  //     </>
  //   );
  // }

  // annullaAggiungi() {
  //   this.setState({ AggiungiUnaLinea: false, nomeArea: "" });
  // }

  // confremaAggiungi() {
  //   this.nuovaLinea = {
  //     nomeArea: this.state.nomeArea,
  //   };

  //   this.dashboardImpostazioniService.insertLinea(this.nuovaLinea, (result) => {
  //     if (result.status === 200) {
  //       toast.success("Area aggiunta con successo");
  //     } else {
  //       toast.error("Qualcosa è andato storto");
  //     }

  //     this.dashboardImpostazioniService.getDataTableLenee((Linee) => {
  //       Linee.data.map((impostazioniSaznione) => {
  //         impostazioniSaznione.statobottne = true;
  //         impostazioniSaznione.bottoniEditi = true;
  //       });
  //       this.setState({
  //         impostazioniSaznione: Linee.data,
  //         AggiungiUnaLinea: false,
  //         nomeArea: "",
  //       });
  //     });
  //   });
  // }

  // onChangeNuovaLinea(event) {
  //   this.state.nomeArea = event.target.value;
  //   this.setState({ nomeArea: this.state.nomeArea });
  // }

  // AggiungiUnaLinea() {
  //   return (
  //     <>
  //       <Modal size="lg" show={this.state.AggiungiUnaLinea}>
  //         <Modal.Header>
  //           <Modal.Title>Aggiungi una nuova Area</Modal.Title>
  //         </Modal.Header>
  //         <Modal.Body>
  //           <label>Nome Area</label>
  //           <input
  //             className="form-control"
  //             type="text"
  //             value={this.state.nomeArea}
  //             onChange={this.onChangeNuovaLinea.bind(this)}
  //           />
  //         </Modal.Body>
  //         <Modal.Footer>
  //           <Button
  //             variant="secondary"
  //             onClick={this.annullaAggiungi.bind(this)}
  //           >
  //             Annulla
  //           </Button>
  //           <Button
  //             variant="primary"
  //             onClick={this.confremaAggiungi.bind(this)}
  //           >
  //             Aggiungi Area
  //           </Button>
  //         </Modal.Footer>
  //       </Modal>
  //     </>
  //   );
  // }

  getSettings(reset) {
    if(reset == null || reset == undefined) reset = true;
    this.dashboardImpostazioniService.getDataTableSettings(
      (settings) => {
        settings.map((impostazioniSaznione) => {
          if(reset) {
            impostazioniSaznione.statobottne = true;
            impostazioniSaznione.bottoniEditi = true;
          }
          this.state.impostazioniSaznioneFissa.map(
            (valore) => {
              if (
                impostazioniSaznione.key ===
                valore.key
              ) {
                if(impostazioniSaznione.key
                  .toString()
                  .includes("giorni")){
                    valore.value = impostazioniSaznione.value
                  }else if(impostazioniSaznione.key
                    .toString() === "dll_conf"){
                    valore.value = impostazioniSaznione.value
                  }
                  else{
                    valore.value = parseFloat(impostazioniSaznione.value / 100)
                    .toFixed(2)
                    .toString()
                    .replace(".", ",");
                  }
                if(reset) {
                  valore.statobottne = true;
                  valore.bottoniEditi = true;
                }
              }
            }
          );
        });
              
        this.dashboardImpostazioniService.getSwaggerStatus((value) => {
          let index = settings.findIndex((setting) => setting.key === "doc_status");
          var foundSetting;
          if(index > -1) {
            foundSetting = settings[index];
            foundSetting.value = value;
            settings.splice(index, 1);
          } else {
            foundSetting = {
              key: "doc_status",
              value: value
            };
          }
          if(reset) {
            foundSetting.statobottne = true;
            foundSetting.bottoniEditi = true;
          }
          settings.push(foundSetting);
          let fixedSetting = this.state.impostazioniSaznioneFissa.find((setting) => setting.key === "doc_status");
          fixedSetting.value = value;
          if(reset) {
            fixedSetting.statobottne = true;
            fixedSetting.bottoniEditi = true;
          }
          
          this.setState({
            impostazioniSaznione: settings,
            isSwaggerValueChanged: false,
            loading: false
          });
        })
      }
    );
  }

  changeSwaggerSwitchHandler(index){
    let setting = this.state.impostazioniSaznioneFissa[index];
    setting.value = !setting.value
    this.setState({
      state: this.state.impostazioniSaznioneFissa,
      isSwaggerValueChanged: true
    });
  }

  changeSwitchHandler(index){

    if(this.state.impostazioniSaznioneFissa[index].value === "1"){
      this.state.impostazioniSaznioneFissa[index].value = "0"
      this.setState({ state: this.state.impostazioniSaznioneFissa });
    }else{
      this.state.impostazioniSaznioneFissa[index].value = "1"
      this.setState({ state: this.state.impostazioniSaznioneFissa });
    }

  }

  onChangeValueImpoSaznione(event) {
    const id = parseInt(event.target.id);
    this.state.impostazioniSaznioneFissa[id].value = event.target.value
      .toString()
      .replaceAll(".", ",");
    this.setState({ state: this.state.impostazioniSaznioneFissa });
  }
  onChangeValueImpoSaznioneGiorni(event) {
    const id = parseInt(event.target.id);
    this.state.impostazioniSaznioneFissa[id].value = event.target.value
      .toString()
      .replaceAll(".", "").replaceAll(",","");
    this.setState({ state: this.state.impostazioniSaznioneFissa });


    // if (!validNumbersInput.test(this.state.impostazioniSaznioneFissa[id].value)
    // ) {
    //   // this.setState({ erroreGiorni: true });
    //   this.state.impostazioniSaznioneFissa[id].erroreGiorni = true
    // } else {
    //   // this.setState({ erroreGiorni: false });
    //   this.state.impostazioniSaznioneFissa[id].erroreGiorni = false

    // }

    // const re = /^[0-9\b]+$/;
    // if (event.target.value === '' || re.test(event.target.value)) {
    //   this.setState({ state: this.state.impostazioniSaznioneFissa });
    // }
  }

  tabellaAree() {
    this.state.impostazioniSaznioneFissa.map((impostazioniSaznione, index) => {
      if (impostazioniSaznione.key.toString().includes("giorni")) {
        // impostazioniSaznione.value = parseInt(impostazioniSaznione.value);
        impostazioniSaznione.erroreGiorni = false
      }
    });
    return (
      <>
        <table class="table table-bordered text-center">
          <thead>
            <tr>
              <th scope="col">Configurazioni</th>
              <th scope="col">Valori</th>
              <th scope="col">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {this.state.impostazioniSaznioneFissa.map(
              (impostazioniSaznione, index) => {
                // console.log(impostazioniSaznione);

                return (
                  <>
                    <tr>
                      <th className="text-left">
                        {/* <input
                        id={index}
                        // disabled={impostazioniSaznione.statobottne}
                        disabled={true}
                        className="form-control"
                        type="text"
                        value={impostazioniSaznione.nome}
                        // onChange={this.onChangeNomelineea.bind(this)}
                      /> */}

                        {impostazioniSaznione.key === "spesa_notifica"
                          ? "Spesa Notifica"
                          : impostazioniSaznione.key === "spesa_procedura"
                          ? "Spesa Procedura"
                          : impostazioniSaznione.key === "spesa_istruttoria"
                          ? "Spesa Istruttoria"
                          : impostazioniSaznione.key === "spesa_penale"
                          ? "Spesa Penale"
                          : impostazioniSaznione.key === "giorni_notifica"
                          ? "Giorni Notifica"
                          : impostazioniSaznione.key === "giorni_notifica_minore"
                          ? "Giorni Notifica Minorenne"
                          : impostazioniSaznione.key === "giorni_sollecito"
                          ? "Giorni Sollecito"
                          : impostazioniSaznione.key === "giorni_ingiunzione"
                          ? "Giorni Ingiunzione"
                          : impostazioniSaznione.key ===
                            "giorni_recupero_credito"
                          ? "Giorni Recupero Credito"
                          : impostazioniSaznione.key === "spesa_notifica_ing"
                          ? "Spesa Notifica Ingiunzione"
                          : impostazioniSaznione.key === "giorni_cancellazioni_dati"
                          ? "Giorni Reset Dati"
                          : impostazioniSaznione.key === "giorni_cancellazioni_dati_posizione"
                          ? "Giorni Reset Dati Posizione"
                          : impostazioniSaznione.key === "TA1"
                          ? "TA1 (Urbana)"
                          : impostazioniSaznione.key === "TA2"
                          ? "TA2 (EXTRAURBANO 1)"
                          : impostazioniSaznione.key === "TA3"
                          ? "TA3 (EXTRAURBANO 2)"
                          : impostazioniSaznione.key === "TA4"
                          ? "TA4 (EXTRAURBANO 3)"
                          : impostazioniSaznione.key === "TA5"
                          ? "TA5 (EXTRAURBANO 4)"
                          : impostazioniSaznione.key === "TA6"
                          ? "TA6 (EXTRAURBANO 5)"
                          : impostazioniSaznione.key === "TA7"
                          ? "TA7 (Senza tariffa)"
                          : impostazioniSaznione.key === "SZMC_RID"
                          ? "SZMC_RID (Sanzione amministrativa ridotta)"
                          : impostazioniSaznione.key === "SZMC_INT"
                          ? "SZMC_INT (Sanzione amministrativa intera)"
                          : impostazioniSaznione.key === "SZING"
                          ? "SZING (Importo amministrativo ingiunzione)"
                          : impostazioniSaznione.key === "dll_conf"
                          ? "Configurazione DLL"
                          : impostazioniSaznione.key === "doc_status"
                          ? "Stato documentazione"
                          : impostazioniSaznione.key}

                        {/* <span>{impostazioniSaznione.key.toString().replaceAll("_", " ")}</span> */}
                      </th>
                      <th>
                        {impostazioniSaznione.key
                          .toString()
                          .includes("giorni") ? (
                            <>
                          <input
                            id={index}
                            disabled={impostazioniSaznione.statobottne}
                            className="form-control"
                            type="text"
                            value={impostazioniSaznione.value}
                            onChange={this.onChangeValueImpoSaznioneGiorni.bind(
                              this
                            )}
                          />
                          {/* {this.state.erroreGiorni ? <small className="text-danger">Solo numeri interi</small>: ""} */}
                          </>
                            ) : impostazioniSaznione.key.toString() === "dll_conf"
                            ? (
                              <>
                                {impostazioniSaznione.statobottne && 
                                  <div>
                                    {impostazioniSaznione.value === "1" 
                                    ?(
                                      <ul class="list-group">
                                        <li class="list-group-item active text-center">
                                          Attivo
                                        </li>{" "}
                                      </ul>
                                    ) : (
                                      <ul class="list-group">
                                        <li class="list-group-item text-center">Disattivato</li>{" "}
                                      </ul>
                                    )
                                    }
                                  </div>}
                                {!impostazioniSaznione.statobottne &&
                                <BootstrapSwitchButton
                                  checked={ this.state.impostazioniSaznioneFissa[index].value === "1" ? true : false}
                                  onChange={()=>this.changeSwitchHandler(index)}
                                  onlabel="Attivo"
                                  offlabel="Disattivato"
                                  style="w-100 mx-1"
                                />}
                            </>) : impostazioniSaznione.key.toString() === "doc_status"
                            ? (
                              <>
                                {impostazioniSaznione.statobottne && 
                                  <div>
                                    {impostazioniSaznione.value
                                    ?(
                                      <ul class="list-group">
                                        <li class="list-group-item active text-center">
                                          Abilitata
                                        </li>{" "}
                                      </ul>
                                    ) : (
                                      <ul class="list-group">
                                        <li class="list-group-item text-center">Non abilitata</li>{" "}
                                      </ul>
                                    )
                                    }
                                  </div>}
                                {!impostazioniSaznione.statobottne &&
                                <BootstrapSwitchButton
                                  checked={ this.state.impostazioniSaznioneFissa[index].value }
                                  onChange={()=>this.changeSwaggerSwitchHandler(index)}
                                  onlabel="Attivo"
                                  offlabel="Disattivato"
                                  style="w-100 mx-1"
                                />}
                              </>) : impostazioniSaznione.key
                        .toString()
                        .includes("percentuale_payroll") ? <div className="input-group mb-2">
                        <div className="input-group-prepend">
                          <span className="input-group-text">%</span>
                        </div>
                        <input
                          id={index}
                          disabled={impostazioniSaznione.statobottne}
                          className="form-control"
                          type="text"
                          value={impostazioniSaznione.value}
                          onChange={this.onChangeValueImpoSaznione.bind(
                            this
                          )}
                        />
                      </div> : (
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">€</span>
                            </div>
                            <input
                              id={index}
                              disabled={impostazioniSaznione.statobottne}
                              className="form-control"
                              type="text"
                              value={impostazioniSaznione.value}
                              onChange={this.onChangeValueImpoSaznione.bind(
                                this
                              )}
                            />
                          </div>
                        )}
                        {/* <div className="input-group mb-3">
                          <div className="input-group-prepend">
                            <span className="input-group-text">€</span>
                          </div>
                          <input
                            id={index}
                            disabled={impostazioniSaznione.statobottne}
                            className="form-control"
                            type="text"
                            value={impostazioniSaznione.Valore}
                            onChange={this.onChangeValueImpoSaznione.bind(this)}
                          />
                        </div> */}
                      </th>
                      <td>
                        {impostazioniSaznione.bottoniEditi ? (
                          <>
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                // this.dashboardImpostazioniService.getDataTableLenee(
                                //   (Linee) => {
                                //     Linee.map(
                                //       (impostazioniSaznione, indeds) => {
                                //         if (indeds === index) {
                                //           impostazioniSaznione.statobottne = false;
                                //           impostazioniSaznione.bottoniEditi = false;
                                //         } else {
                                //           impostazioniSaznione.statobottne = true;
                                //           impostazioniSaznione.bottoniEditi = true;
                                //         }
                                //       }
                                //     );
                                //     //   console.log(Linee);
                                //     this.setState({
                                //       impostazioniSaznione: Linee,
                                //     });
                                //   }
                                // );
                                // this.setState({ loading: false });

                                if(this.state.impostazioniSaznioneFissa.some((setting) => !setting.statobottne || !setting.bottoniEditi) != null) {
                                  this.getSettings(false);
                                }

                                this.state.impostazioniSaznioneFissa.map(
                                  (impostazioniSaznione, indeds) => {
                                    if (indeds === index) {
                                      impostazioniSaznione.statobottne = false;
                                      impostazioniSaznione.bottoniEditi = false;
                                    } else {
                                      impostazioniSaznione.statobottne = true;
                                      impostazioniSaznione.bottoniEditi = true;
                                    }
                                  }
                                );

                                this.setState({ state: this.state.impostazioniSaznioneFissa })

                                this.setState({ loading: false });
                              }}
                            >
                              {" "}
                              <i className="fas fa-fw fa-edit"></i>{" "}
                            </button>
                            {/* &nbsp;
                          <button
                            className="btn btn-danger"
                            onClick={() =>
                              this.setState({
                                eliminaModal: true,
                                idDaEliminare: this.state.impostazioniSaznione[index].idArea,
                              })
                            }
                          >
                            {" "}
                            <i className="fas fa-fw fa-trash"></i>{" "}
                          </button>
                          &nbsp; */}
                          </>
                        ) : (
                          <>
                          {impostazioniSaznione.key
                          .toString()
                          .includes("giorni") ?<button
                          className="btn btn-success"
                          onClick={() => {
                            // console.log(
                            //   this.state.impostazioniSaznione[index]
                            // );
                            this.state.impostazioniSaznioneFissa[
                              index
                            ].value = this.state.impostazioniSaznioneFissa[
                              index
                            ].value
                              .toString()
                              .replace(",", ".");
                            this.lineaEdit = {
                              key: this.state.impostazioniSaznioneFissa[
                                index
                              ].key,
                              value: 
                                this.state.impostazioniSaznioneFissa[index]
                                  .value 
                              
                            };
                            this.setState({loadingButton:true})
                            this.dashboardImpostazioniService.SalvaGesTioneValori(
                              this.lineaEdit,
                              (result) => {
                                this.setState({loadingButton:false});
                                if (result.status === 200) {
                                  toast.success("Valore Aggiornato");
                                } else {
                                  toast.error("Valore non Aggiornato");
                                }
                                /*this.dashboardImpostazioniService.getDataTableLenee(
                                  (Linee) => {
                                    Linee.map((impostazioniSaznione) => {
                                      impostazioniSaznione.statobottne = true;
                                      impostazioniSaznione.bottoniEditi = true;
                                      this.state.impostazioniSaznioneFissa.map(
                                        (valore) => {
                                          if (
                                            impostazioniSaznione.key ===
                                            valore.key
                                          ) {
                                            if(impostazioniSaznione.key
                                              .toString()
                                              .includes("giorni")){
                                                valore.value = impostazioniSaznione.value
                                              }else{
                                                valore.value = parseFloat(impostazioniSaznione.value / 100)
                                                .toFixed(2)
                                                .toString()
                                                .replace(".", ",");
                                              }
                                            valore.statobottne = true;
                                            valore.bottoniEditi = true;
                                          }
                                        }
                                      );
                                    });
                                    this.setState({
                                      impostazioniSaznione: Linee,
                                    });
                                  }
                                );*/
                                this.getSettings();
                              }
                            );
                          }}
                          >{" "}
                          {this.state.loadingButton ? <LoadSpinner/> :(<i className="fas fa-fw fa-check"></i>)}
                          {" "}
                          </button> : impostazioniSaznione.key.toString() === "dll_conf"
                        ? <button
                        className="btn btn-success"
                        onClick={() => {
                          // console.log(
                          //   this.state.impostazioniSaznione[index]
                          // );
                          this.state.impostazioniSaznioneFissa[
                            index
                          ].value = this.state.impostazioniSaznioneFissa[
                            index
                          ].value.toString()
                          this.lineaEdit = {
                            key: this.state.impostazioniSaznioneFissa[
                              index
                            ].key,
                            value:
                              this.state.impostazioniSaznioneFissa[index]
                                .value
                          };
                          this.dashboardImpostazioniService.SalvaGesTioneValori(
                            this.lineaEdit,
                            (result) => {
                              if (result.status === 200) {
                                toast.success("Valore Aggiornato");
                              } else {
                                toast.error("Valore non Aggiornato");
                              }
                              this.getSettings();
                            }
                          );
                        }}
                      >
                        {" "}
                        <i className="fas fa-fw fa-check"></i>{" "}
                      </button>
                         : impostazioniSaznione.key.toString() === "doc_status"
                         ? <button
                         className="btn btn-success"
                         onClick={() => {
                           if(this.state.isSwaggerValueChanged) {
                             this.dashboardImpostazioniService.changeSwaggerStatus(
                               (result) => {
                                 if (result.status === 200) {
                                   toast.success("Valore Aggiornato");
                                 } else {
                                   toast.error("Valore non Aggiornato");
                                 }
                                 this.getSettings();
                               }
                             );
                           } else {
                             let settings = this.state.impostazioniSaznioneFissa;
                             let fixedSetting = settings.find((setting) => setting.key === "doc_status");
                             fixedSetting.statobottne = true;
                             fixedSetting.bottoniEditi = true;
                             
                             this.setState({
                               impostazioniSaznioneFissa: settings
                             });
                           }
                         }}
                       >
                         {" "}
                         <i className="fas fa-fw fa-check"></i>{" "}
                       </button> : <button
                          className="btn btn-success"
                          onClick={() => {
                            // console.log(
                            //   this.state.impostazioniSaznione[index]
                            // );
                            this.state.impostazioniSaznioneFissa[
                              index
                            ].value = this.state.impostazioniSaznioneFissa[
                              index
                            ].value
                              .toString()
                              .replace(",", ".");
                            this.lineaEdit = {
                              key: this.state.impostazioniSaznioneFissa[
                                index
                              ].key,
                              value: parseInt(
                                this.state.impostazioniSaznioneFissa[index]
                                  .value * 100
                              ),
                            };
                            this.dashboardImpostazioniService.SalvaGesTioneValori(
                              this.lineaEdit,
                              (result) => {
                                if (result.status === 200) {
                                  toast.success("Valore Aggiornato");
                                } else {
                                  toast.error("Valore non Aggiornato");
                                }
                                this.getSettings();
                              }
                            );
                          }}
                        >
                          {" "}
                          <i className="fas fa-fw fa-check"></i>{" "}
                        </button>}
                            
                            &nbsp;
                            <button
                              className="btn btn-danger"
                              id={index}
                              onClick={() => {
                                // this.dashboardImpostazioniService.getDataTableLenee(
                                //   (Linee) => {
                                //     Linee.map(
                                //       (impostazioniSaznione, indeds) => {
                                //         if (indeds === index) {
                                //           impostazioniSaznione.statobottne = true;
                                //           impostazioniSaznione.bottoniEditi = true;
                                //         } else {
                                //           impostazioniSaznione.statobottne = true;
                                //           impostazioniSaznione.bottoniEditi = true;
                                //         }
                                //       }
                                //     );
                                //     this.setState({
                                //       impostazioniSaznione: Linee,
                                //     });
                                //   }
                                // );
                                // this.setState({ loading: false });

                                this.state.impostazioniSaznioneFissa.map(
                                  (impostazioniSaznione, indeds) => {
                                    if (indeds === index) {
                                      impostazioniSaznione.statobottne = true;
                                      impostazioniSaznione.bottoniEditi = true;
                                    } else {
                                      impostazioniSaznione.statobottne = true;
                                      impostazioniSaznione.bottoniEditi = true;
                                    }
                                  }
                                );
                                this.getSettings();

                                this.setState({ loading: false });
                              }}
                            >
                              {" "}
                              <i className="fas fa-fw fa-times"></i>{" "}
                            </button>
                            &nbsp;
                          </>
                        )}
                      </td>
                    </tr>
                  </>
                );
              }
            )}
          </tbody>
        </table>
      </>
    );
  }
  render() {
    // console.log(this.state.impostazioniSaznione);
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
            Configurazione Valori<br></br>
            </h1>
            {/* <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              > 
                Aree &#8594; In Lavorazione
              </small>< */}

            {/* <button
              type="button"
              class="btn btn-warning"
              onClick={() => {
                this.setState({ AggiungiUnaLinea: true });
              }}
            >
              {" "}
              <i className="fas fa-plus fa-sm text-white"></i> &nbsp;Aggiungi
              una nuova Area
            </button>
            <a className=""></a> */}
          </div>
          <br />
          <br />
          <div className="col">{this.tabellaAree()}</div>
          {/* {this.eliminaModal()} */}
          {/* {this.AggiungiUnaLinea()} */}
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(Linee);
